import { makeStyles } from "@material-ui/core";

export const useEAFDETablesStyles = makeStyles((theme) => ({
	agGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		minHeight: "348px",
		maxHeight: "348px",
	},
	upperAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 10px 50px 10px",
		minHeight: "578px",
		maxHeight: "578px",
	},
	middleTextfields: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "18px 6px 10px 6px",
		minHeight: "350px",
		maxHeight: "350px",
	},
	dynamicHeight: {
		height: (props?: { rowCount?: number }) => {
			const rowCount = props?.rowCount ?? 4; // Default to 4 if rowCount is not provided
			return `${Math.min(350 + (rowCount - 4) * 50, 550)}px`;
		},
		// 350px base for 4 rows, 50px for each additional row, maximum 550px (for 8 rows)
	},
	readonlyAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px ",
		height: "400px",
		minHeight: "400px",
	},
	electrodeEventsAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "230px",
		minHeight: "230px",
	},
	lowerAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px 6px 50px 6px",
		height: "468px",
		minHeight: "468px",
	},
	manualAutoButton: {
		minWidth: "5px",
		padding: "6px 8px",
		cursor: "auto",
	},
	smAgGridBox: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "10px 10px 10px 10px",
		height: "281px",
		minHeight: "350px",
	},
	// Notes
	outlinedTextarea: {
		width: "100%",
		padding: "10px 12px",
		border: `1px solid ${theme.palette.grey[400]}`,
		borderRadius: theme.shape.borderRadius,
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.fontSize,
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		"&:hover": {
			borderColor: theme.palette.text.primary,
		},
		"&:focus": {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
			outline: "none",
		},
		"&::placeholder": {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
}));

export const useManualAutoButtonStyles = makeStyles((theme) => ({
	manualAutoButton: {
		minWidth: "5px",
		padding: "6px 8px",
		cursor: "auto",
	},
}));
